import React from 'react';
import { useSelector } from 'react-redux';
import AddEditCarrierPermissions from './AddEditPermissions';
import CarrierTable from './CarrierTable';

export default function CarrierPermissions({ user = {} }) {
  const { page } = useSelector(store => store.permissions.carrier);

  if (page === 'addEdit') return (<AddEditCarrierPermissions user={user} />);
  if (page === 'carrierTable') return (<CarrierTable />);
}
